<template>
    <div class="no-top-offer p-2 mb-2 text-center">
        <p class="mt-3 mb-3">Online gambling is not available in this state. We have more information on why:</p>
        <a :href="homepageLink" class="button-ghost-black mb-3">Online Gambling in {{ state }}</a>
    </div>

</template>

<script>
    export default {
    name: 'no-state-offer',
    props: {
        small: {
            type: Boolean,
            required: false,
            default: false,
        },
        state: {
            type: String,
            required: true,
        },
        productType: {
            type: String,
            required: false,
        },
        productTypeFeature: {
            type: String,
            required: false,
        },
        position: {
            type: String,
            required: false,
            default: 'Middle Content',
            validator: (prop) => [
                'Footer',
                'Middle Content'
            ].includes(prop)
        },
        homepageLink: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            randomNumber: Math.random() * 100000,
            showEmailThankYou: false,
            currentUrl: window.location.href,
            translations: {
                "email_enter_email" : "Enter email",
                "subscribe_button_text" : "GET STARTED",
                "agree_message" : "Yes, I confirm that I am 21+ and I agree to receiving emails on gambling news and offers",
                "input_validation_error" : "Please fill out this field",
                "checkbox_validation_error" : "Please check this box if you want to proceed",
                "email_validation_error" : "Please enter a valid email address",
            },
            checkbox: {
                "checked": false,
                "required": true,
                "name": "agree"
            }
        }
    }
};

</script>

<style lang="scss" scoped>

</style>